// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { EventProperties } from '../constants/tracking-types';

export { Events } from '../constants/tracking-types';

declare global {
  interface Window {
    analytics: {
      identify: (...args: any[]) => void;
      page: (...args: any[]) => void;
      track: (...args: any[]) => any;
    };
    ours: any;
  }
}

export function track<T extends keyof EventProperties>(
  name: T,
  properties?: EventProperties[T]
): void {
  window.analytics?.track && window.analytics.track(name, properties);

  if (window.ours) {
    if (name === 'Button Clicked') {
      const buttonClickedProperties =
        properties as EventProperties['Button Clicked'];
      if (buttonClickedProperties?.url === '/quiz/psi-2/signup/email') {
        window.ours('track', 'SubmitApplication');
      } else if (
        buttonClickedProperties?.url === '/quiz/psi-2/signup/stateOfResidence'
      ) {
        window.ours('track', 'Lead');
      }
    }
  }
}

export function page(): void {
  window.analytics?.page && window.analytics.page();
}
